/** A trigger that could not finish; `code` picks the screen's text. */
export class TriggerError extends Error {
  constructor(public readonly code: 'no_motion' | 'aborted') {
    super(`trigger_${code}`)
    this.name = 'TriggerError'
  }
}
